import { render, staticRenderFns } from "./PresentationQualityControl.vue?vue&type=template&id=85285916&scoped=true"
import script from "./PresentationQualityControl.vue?vue&type=script&lang=js"
export * from "./PresentationQualityControl.vue?vue&type=script&lang=js"
import style0 from "./PresentationQualityControl.vue?vue&type=style&index=0&id=85285916&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85285916",
  null
  
)

export default component.exports